/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatReopenModal.vue?vue&type=template&id=3693bc1e"
import script from "./ChatReopenModal.vue?vue&type=script&lang=js"
export * from "./ChatReopenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3693bc1e')) {
      api.createRecord('3693bc1e', component.options)
    } else {
      api.reload('3693bc1e', component.options)
    }
    module.hot.accept("./ChatReopenModal.vue?vue&type=template&id=3693bc1e", function () {
      api.rerender('3693bc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatReopenModal.vue"
export default component.exports